import { GraduationCap } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { TEACHERS } from "@/data/content";

const Teachers = () => (
    <section id="teachers" className="py-24 lg:py-32" data-testid="teachers-section">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
            <SectionHeading
                eyebrow="Meet the Teachers"
                title="Experienced Indian educators, hand-picked with care"
                copy="Every Hindi Ganga teacher brings strong academic credentials and years of experience teaching students online across the US, Australia, Canada and beyond."
            />
            <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="teachers-grid">
                {TEACHERS.map((t, i) => (
                    <Reveal key={t.name} delay={i * 0.08}>
                        <article
                            className="group flex h-full flex-col overflow-hidden rounded-3xl border border-border bg-cream card-shadow transition-all duration-300 hover:-translate-y-1.5 hover:lift-shadow"
                            data-testid={`teacher-card-${t.name.toLowerCase().replace(/\s/g, "-")}`}
                        >
                            {t.photo && (
                                <div className="relative overflow-hidden">
                                    <img
                                        src={t.photo}
                                        alt={`${t.name}, ${t.subjects} teacher at Hindi Ganga Online Classes`}
                                        className="aspect-[4/5] w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
                                    />
                                    <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-teal-dark/90 to-transparent px-6 pb-4 pt-16">
                                        <h3 className="font-serif text-xl font-semibold tracking-tight text-cream">{t.name}</h3>
                                        <p className="mt-0.5 text-xs font-medium uppercase tracking-[0.16em] text-saffron">{t.subjects} Teacher</p>
                                    </div>
                                </div>
                            )}
                            <div className="flex flex-1 flex-col p-8">
                                {!t.photo && (
                                    <>
                                        <div className={`grid h-16 w-16 place-items-center rounded-full ${t.color} font-serif text-xl font-semibold text-cream`}>
                                            {t.initials}
                                        </div>
                                        <h3 className="mt-6 font-serif text-xl font-semibold tracking-tight text-ink">{t.name}</h3>
                                        <p className="mt-1 text-sm font-medium text-saffron-dark">{t.subjects}</p>
                                    </>
                                )}
                                <p className={`flex items-center gap-2 text-xs text-muted-foreground ${t.photo ? "" : "mt-3"}`}>
                                    <GraduationCap className="h-4 w-4 shrink-0 text-teal" />
                                    {t.credentials}
                                </p>
                                <p className="mt-4 flex-1 border-t border-border pt-4 font-serif text-sm italic leading-relaxed text-muted-foreground">
                                    "{t.note}"
                                </p>
                                <p className="mt-4 text-xs font-medium uppercase tracking-[0.18em] text-teal">{t.experience}</p>
                            </div>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
export default Teachers;
